import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import { Box, CardHeader } from '@mui/material';
import { faFile } from '@fortawesome/free-solid-svg-icons';

const BotChatUploadFile = (props) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
            <Card>
                <CardHeader
                    avatar={
                        <Avatar sx={{ bgcolor: 'primary.main' }}>
                            <FontAwesomeIcon icon={faFile}  />
                        </Avatar>
                    }
                    title={props.payload?.file}
                    subheader="file"
                    sx={{position: 'relative'}}
                />
            </Card>

        </Box>
    );
};

export default BotChatUploadFile;
